import { constantRouterMap } from '@/router';

/**
* 添加动态(菜单)路由
* @param {*} menuList 菜单列表
* @param {*} routes 递归创建的动态(菜单)路由
*/
function addDynamicRoutes (menuList = [], routes = []){
	let temp = []
	for(let i=0; i<menuList.length; i++) {
		if (menuList[i].children && menuList[i].children.length >= 1) {
			temp = temp.concat(menuList[i].children);
	  	}else if(menuList[i].menuUrl && /\S/.test(menuList[i].menuUrl)){
			menuList[i].menuUrl = menuList[i].menuUrl.replace(/^\//, '');

			// 创建路由配置
			let route = {
				path: menuList[i].menuUrl,
				component: null,
				meta:{
					icon: menuList[i].menuIcon,
					index: menuList[i].id,
					parentId: menuList[i].parentId,
					name: menuList[i].menuName,
					routeKey: menuList[i].menuUrl.replace(/\/:.*(\/{0,1})/,'$1'),
				}
			}
			try{
				// 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
				// 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到 传参照常
				let array = menuList[i].menuUrl.split('/');
				let url = '';
				for(let i=0; i<array.length; i++){
					// 去除掉传参路径
					if(!/\:.*/.test(array[i])){
						url += array[i].substring(0,1).toUpperCase() + array[i].substring(1) + '/'
					}
				}
				url = url.substring(0, url.length - 1);
				route['component'] = resolve => require([`@/views/${url}`], resolve);
			}catch(e){}
			routes.push(route)
		}
	}
	
	if(temp.length >= 1) {
		addDynamicRoutes(temp, routes)
	}else{
		// console.log('动态路由加载完成')
	}
	return routes
}


export default {
	state: {
		addRouters: [],  // 导航菜单树
		navTree: [],
		routers: constantRouterMap,
	},
	getters: {
	},
	mutations: {
		SET_ROUTERS(state, routers) {  // 设置导航菜单树
			state.addRouters = routers;
			state.routers = constantRouterMap.concat(routers);
		},
		SET_NAVTREE: (state, menu) => {
			state.navTree = menu;
		},
	},
	actions: {
		GenerateRoutes({ commit }, menus) {
			return new Promise(resolve => {
				let accessedRouters = [];
				if (menus.length > 0){
					let rootRoute = {
						path: '/',
						component: resolve => require(['@/views/Home'], resolve),
						redirect: '',
						children: []
					}
					let routes = addDynamicRoutes(menus, rootRoute.children);
					rootRoute.redirect = `/${routes[0].path}`;
					accessedRouters.push(rootRoute)
				}
				commit('SET_ROUTERS', accessedRouters);
				commit('SET_NAVTREE', menus);
				resolve();
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js